//@flow
import { commitMutation, graphql } from 'react-relay';
import type { PayloadError } from 'react-relay';

const mutation = graphql`
    mutation profileEmailMutation($input: DesignProfileBasicMutationInput!) {
        designProfileBasicMutation(input: $input) {
            tradeFirm {
                publicProfile {
                    email
                }
            }
        }
    }
`;

type ProfileEmailMutationArgs = {
    firmId: string,
    email: string,
};

export const profileEmailMutation = (
    environment: Object,
    args: ProfileEmailMutationArgs
): Promise<void> => {
    const { firmId, email } = args;
    const input = {
        serviceId: firmId,
        email,
    };

    return new Promise((resolve, reject) => {
        const onCompleted = (response, errors: ?Array<PayloadError>) => {
            if (errors && errors.length) {
                reject(errors);
            }
            resolve(response);
        };

        const onError = (error: Error) => {
            reject([error]);
        };

        try {
            commitMutation(environment, {
                mutation,
                variables: { input },
                onCompleted,
                onError,
            });
        } catch (error) {
            reject([error]);
        }
    });
};
